import { render, staticRenderFns } from "./TableWidget.vue?vue&type=template&id=47981481&scoped=true"
import script from "./TableWidget.vue?vue&type=script&lang=js"
export * from "./TableWidget.vue?vue&type=script&lang=js"
import style0 from "./TableWidget.vue?vue&type=style&index=0&id=47981481&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47981481",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
installComponents(component, {VChip,VDataTable,VIcon,VProgressLinear})
